import {IoMdClose} from 'react-icons/io'

import {
  BannerCloseBtn,
  BannerDummyBtn,
  BannerContent,
  LogoImg,
  BannerContentContainer,
  BannerContainer,
} from './styledComponents'
import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

const Banner = () => (
  <NxtWatchContext.Consumer>
    {value => {
      const {bannerStatus, closeBanner} = value

      if (bannerStatus === true) {
        return (
          <BannerContainer data-testid="banner">
            <BannerContentContainer>
              <LogoImg
                src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png"
                alt="nxt watch logo"
              />
              <BannerContent>
                Buy Nxt Watch Premium prepaid plans with UPI
              </BannerContent>
              <BannerDummyBtn>GET IT NOW</BannerDummyBtn>
            </BannerContentContainer>
            <BannerCloseBtn
              type="button"
              onClick={closeBanner}
              data-testid="close"
            >
              <IoMdClose />
              {}
            </BannerCloseBtn>
          </BannerContainer>
        )
      }
      return null
    }}
  </NxtWatchContext.Consumer>
)

export default Banner
